import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Paper,
  List,
  ListItemButton,
  Stack,
  Typography,
  useMediaQuery,
  Divider,
  Avatar,
  IconButton,
  Tooltip,
  Snackbar,
} from "@mui/material";
import BusinessCenterRounded from "@mui/icons-material/BusinessCenterRounded"; // Job icon
import LaunchRounded from "@mui/icons-material/LaunchRounded"; // Launch icon
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";
import { myCandidatesSelector } from "../redux/selector";
import { useDispatch, useSelector } from "react-redux";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { userSelector } from "../../user-redux/selector";
import Key from "../../../clientVariables.json";
import MuiAlert from "@mui/material/Alert";

import {
  getCandidateInterestedJobs,
  getJobDetailsAction,
  selectedTabViewAction,
  sendJobToCandidateAction,
  updateSubmissionsAction,
} from "../redux/action";
import moment from "moment";
import axios from "axios";

const IntrestedJobs = ({ refreshKey }) => {
  const { candidateDetails, candidateInterestedJobs, candidateInterestedJobsLoading, candidateDetailLoading, jobDetails } =
    useSelector(myCandidatesSelector);

  const { user } = useSelector(userSelector);

  const dispatch = useDispatch();
  const [selectedJobId, setSelectedJobId] = useState(null);

  const [hasMore, setHasMore] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [sendJobFormOpen, setSendJobFormOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("success");
  const [toastMessage, setToastMessage] = useState(null);

  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");

  const containerStyles = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };
  useEffect(() => {
    // Always refetch when refreshKey changes (even for same candidate)
    if (candidateDetails?.candidate_id) {
      dispatch(getCandidateInterestedJobs(candidateDetails?.candidate_id));
    }
  }, [candidateDetails?.candidate_id, dispatch, refreshKey]);

  useEffect(() => {
    if (candidateInterestedJobs?.length > 0) {
      const job = candidateInterestedJobs[0];
      onClickJob(job);
    } else {
      setSelectedJobId(null);
      dispatch(getJobDetailsAction(null));
    }
  }, [candidateInterestedJobs?.length]);

  const fetchMoreCandidates = () => { };

  const onClickJob = (job) => {
    setSelectedJobId(job?.id); // Set the selected job ID
    dispatch(getJobDetailsAction(job?.id));
  };

  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  const isSubmitHandler = (data) => {
    if (data === "success") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("success");
      setToastMessage("Job Sent successfully!");
    } else if (data === "cancel") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("warning");
      setToastMessage("Job Sent Cancel!");
    } else if (data === "exist") {
      setSendJobFormOpen(false);
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Job already submitted to candidate!");
    } else if (data === "error") {
      setOpenToast(true);
      setToastSeverity("error");
      setToastMessage("Something went wrong!");
      window.location.reload();
    }
  };

  // const onSendJob = async (job) => {
  //   const formData = {
  //     candidateName: candidateDetails?.candidate_name,
  //     candidateid: candidateDetails?.candidate_id,
  //     toEmail: candidateDetails?.email,
  //     userid: user?.id,
  //     jobid: jobDetails?.id,
  //     ccmail: [],
  //     subject: jobDetails?.jobtitle,
  //     description: jobDetails?.job_description,
  //     leadid: "",
  //     duration: "",
  //     emailBody: "",
  //     fromEmail: jobDetails?.email_id,
  //     sgfromEmail: user?.username,
  //   };
  //   let updatedData = {
  //     candidateid: formData?.candidateid,
  //     jobid: formData?.jobid,
  //     userid: formData?.userid,
  //     status: "1",
  //   };
  //   const finalData = formData;
  //   const response = await dispatch(
  //     sendJobToCandidateAction(
  //       finalData,
  //       updatedData,
  //       user?.id,
  //       candidateDetails?.candidate_id,
  //       jobDetails?.id
  //     )
  //   );
  //   if (response.data === "Job already submitted to candidate already") {
  //     isSubmitHandler("exist");
  //   } else if (response.data.affectedRows > 0) {
  //     axios.post(`${Key.domain}/submission/accept_manually`, {
  //       candidateid: formData?.candidateid,
  //       jobid: formData?.jobid,
  //       userid: formData?.userid,
  //       resumeid: job?.resume_id,
  //     });

  //     let updatedData2 = {
  //       candidateid: formData?.candidateid,
  //       jobid: formData?.jobid,
  //       userid: formData?.userid,
  //       status: "2",
  //     };
  //     await dispatch(
  //       updateSubmissionsAction(
  //         updatedData2,
  //         formData?.userid,
  //         formData?.candidateid,
  //         formData?.jobid
  //       )
  //     );

  //     dispatch(selectedTabViewAction("Submission"));
  //   }
  // };

  const onSendJob = async () => {
    try {
      const response = await axios.post(
        `${Key.domain}/submission/intrested-submission-accept`,
        {
          candidateid: candidateDetails?.candidate_id,
          jobid: jobDetails?.id,
          userid: user?.id,
          status: "2",
        }
      );
      if (response?.data?.data?.success === 1) {
        setToastSeverity("success");
        setToastMessage("Job submitted successfully");
        setOpenToast(true);

        dispatch(selectedTabViewAction("Submission"));
      }
      else {
        setToastSeverity("warning");
        setToastMessage("Job is already in submission status");
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Send job error:", error);

      setToastSeverity("error");
      setToastMessage("Something went wrong. Please try again.");
      setOpenToast(true);
    }
  };


  const loading = candidateDetailLoading || candidateInterestedJobsLoading;

  return (
    <>
      <Box sx={containerStyles}>
            {loading ? (
              <Box>
                {Array.from({ length: 8 }).map((_, i) => (
                  <LoadingSkeleton key={i} />
                ))}
              </Box>
            ) : !candidateInterestedJobs?.length ? (
              <Typography
                variant="h6"
                align="center"
                sx={{ margin: 2, fontSize: "15px" }}
              >
                No data is available
              </Typography>
            ) : (
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
                {/* Only the Jobs Tab */}
                <InfiniteScroll
                  dataLength={candidateInterestedJobs?.length || 0}
                  next={fetchMoreCandidates}
                  hasMore={hasMore}

                  endMessage={<Typography sx={{ p: 2, textAlign: 'center' }}>No more jobs</Typography>}
                  style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: "auto" }}
                  scrollableTarget="scrollableDiv"
                  pullDownToRefreshThreshold={50}
                >
                  <List id="scrollableDiv"
                    sx={{ flex: 1, p: 0 }}>
                    {candidateInterestedJobs.map((job, i) => (
                        <ListItemButton
                          key={i}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor:
                              selectedJobId === job.id ? "#f0f8ff" : "inherit", // Background color for selected job
                            "&:hover": {
                              backgroundColor: "#e0e0e0", // Hover effect
                            },
                          }}
                          onClick={() => onClickJob(job)}
                          onMouseEnter={() => setHoveredItem(job.id)}
                          onMouseLeave={() => setHoveredItem(null)}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                              flex: 1,
                            }}
                          >
                            <Avatar
                              sx={{
                                height: isDesktopLarge
                                  ? "32px"
                                  : isDesktopMedium
                                    ? "32px"
                                    : isDesktopSmall
                                      ? "26px"
                                      : "24px",
                                width: isDesktopLarge
                                  ? "32px"
                                  : isDesktopMedium
                                    ? "32px"
                                    : isDesktopSmall
                                      ? "26px"
                                      : "24px",
                              }}
                            >
                              <BusinessCenterRounded
                                sx={{
                                  color: "#fff",
                                  height: isDesktopLarge
                                    ? "24px"
                                    : isDesktopMedium
                                      ? "24px"
                                      : isDesktopSmall
                                        ? "16px"
                                        : "14px",
                                  width: isDesktopLarge
                                    ? "24px"
                                    : isDesktopMedium
                                      ? "24px"
                                      : isDesktopSmall
                                        ? "16px"
                                        : "14px",
                                }}
                              />
                            </Avatar>
                            <Stack direction="column" sx={{ flexGrow: 1 }}>
                              <Typography
                                title={job.jobtitle}
                                sx={{
                                  fontSize: isDesktopXS ? "10px" : "12px",
                                  fontWeight: 600,
                                  margin: 0,
                                  width: isDesktopLarge
                                    ? "200px"
                                    : isDesktopMedium
                                      ? "150px"
                                      : isDesktopSmall
                                        ? "100px"
                                        : "80px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {job.jobtitle}
                              </Typography>
                              <Typography
                                sx={{ fontSize: isDesktopXS ? "9px" : "11px" }}
                              >
                                {job.company_name || "N/A"}
                              </Typography>
                              <Typography
                                sx={{ fontSize: isDesktopXS ? "9px" : "11px" }}
                              >
                                {job?.location ? job.location : "Remote"}
                              </Typography>
                            </Stack>
                          </div>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                            }}
                          >
                            <Stack direction="row" spacing={1} sx={{}}>
                              {hoveredItem === job.id && (
                                <Tooltip title="Send Job">
                                  <IconButton sx={{ padding: 0 }}>
                                    <LaunchRounded
                                      style={{ fontSize: "15px" }}
                                      onClick={() => onSendJob(job)}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                              <Tooltip title="Interested" arrow placement="top">
                                <IconButton color="primary" size="small">
                                  <ThumbUpIcon style={{ fontSize: "14px" }} />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                            <Typography
                              sx={{
                                marginTop: "4px",
                                fontSize: isDesktopXS ? "8px" : "10px",
                                color: "#757575",
                              }}
                            >
                              {moment(job.posted_date).fromNow()}
                            </Typography>
                          </Box>
                        </ListItemButton>
                      ))}
                  </List>
                </InfiniteScroll>
              </Box>
            )}

          </Box>
      <Snackbar
        open={openToast}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSuccessToastClose} severity={toastSeverity}>
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default IntrestedJobs;
